(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-actives"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initActives(root) {
    var tabs = root.querySelectorAll('.nba__tab');
    var panels = root.querySelectorAll('.nba__panel');
    function activate(id) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-id') === id;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-id') === id;
        p.classList.toggle('is-active', on);
        if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(t.getAttribute('data-id')); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var next = e.key === 'ArrowRight' ? (i + 1) % tabs.length : (i - 1 + tabs.length) % tabs.length;
        tabs[next].focus(); activate(tabs[next].getAttribute('data-id'));
      });
    });
    return activate;
  }
  function initAll() { document.querySelectorAll('.nba').forEach(initActives); }
  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', initAll); }

  // Theme-Editor: Block auswählen → passenden Tab aktivieren
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest ? e.target.closest('.nba') : null;
    if (!root) { root = document.querySelector('.nba'); }
    if (!root) return;
    var act = initActives(root);
    if (e.detail && e.detail.blockId) { act(e.detail.blockId); }
  });
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('.nba') : null;
    if (root) initActives(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-approach-accordion"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal(root) {
    if (!root.classList.contains('nbaa--anim')) return;
    var items = root.querySelectorAll('.nbaa__r');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var i = [].indexOf.call(items, el);
        setTimeout(function () { el.classList.add('in'); }, Math.max(0, i) * 90);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
  }
  function single(root) {
    // Nur eine Zeile gleichzeitig offen halten
    if (root.getAttribute('data-single') === 'false') return;
    root.querySelectorAll('.nbaa__item').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        root.querySelectorAll('.nbaa__item[open]').forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }
  function init(root) { reveal(root); single(root); }
  function initAll() { document.querySelectorAll('.nbaa').forEach(init); }
  if (document.readyState !== 'loading') { initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector ? e.target.querySelector('.nbaa') : null;
    if (r) { r.querySelectorAll('.nbaa__r').forEach(function (el) { el.classList.add('in'); }); single(r); }
  });
  document.addEventListener('shopify:block:select', function (e) {
    var d = e.target.closest ? e.target.closest('.nbaa__item') : null; if (d) d.open = true;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-approach-intro"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal(root) {
    if (!root.classList.contains('nbai--anim')) return;
    var items = root.querySelectorAll('.nbai__r');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var i = [].indexOf.call(items, el);
        setTimeout(function () { el.classList.add('in'); }, Math.max(0, i) * 90);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });
    items.forEach(function (el) { io.observe(el); });
  }
  function initAll() { document.querySelectorAll('.nbai').forEach(reveal); }
  if (document.readyState !== 'loading') { initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector ? e.target.querySelector('.nbai') : null;
    if (r) { r.querySelectorAll('.nbai__r').forEach(function (el) { el.classList.add('in'); }); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-approach-step"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal(root) {
    if (!root.classList.contains('nbas--anim')) return;
    var items = root.querySelectorAll('.nbas__r');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var i = [].indexOf.call(items, el);
        setTimeout(function () { el.classList.add('in'); }, Math.max(0, i) * 90);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
  }
  function initAll() { document.querySelectorAll('.nbas').forEach(reveal); }
  if (document.readyState !== 'loading') { initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector ? e.target.querySelector('.nbas') : null;
    if (r) { r.querySelectorAll('.nbas__r').forEach(function (el) { el.classList.add('in'); }); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-audience"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal(scope) {
    var items = (scope || document).querySelectorAll('.nbaud__card:not(.in)');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach(function (e) { e.classList.add('in'); }); return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (e) { io.observe(e); });
  }
  if (document.readyState !== 'loading') { reveal(); } else { document.addEventListener('DOMContentLoaded', function () { reveal(); }); }
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-benefitcard"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal(scope) {
    var items = (scope || document).querySelectorAll('.nbbc__item:not(.in)');
    if (!items.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach(function (e) { e.classList.add('in'); }); return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (e) { io.observe(e); });
  }
  if (document.readyState !== 'loading') { reveal(); } else { document.addEventListener('DOMContentLoaded', function () { reveal(); }); }
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-brainbasics"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal(root) {
    if (!root.classList.contains('nbbb--anim')) return;
    var items = root.querySelectorAll('.nbbb__r');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var i = [].indexOf.call(items, el);
        setTimeout(function () { el.classList.add('in'); }, Math.max(0, i) * 80);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    items.forEach(function (el) { io.observe(el); });
  }
  function single(root) {
    // Nur ein Kasten gleichzeitig offen
    root.querySelectorAll('.nbbb__item').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        root.querySelectorAll('.nbbb__item[open]').forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }
  function init(root) { reveal(root); single(root); }
  function initAll() { document.querySelectorAll('.nbbb').forEach(init); }
  if (document.readyState !== 'loading') { initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector ? e.target.querySelector('.nbbb') : null;
    if (r) { r.querySelectorAll('.nbbb__r').forEach(function (el) { el.classList.add('in'); }); single(r); }
  });
  document.addEventListener('shopify:block:select', function (e) {
    var d = e.target.closest ? e.target.closest('.nbbb__item') : null; if (d) d.open = true;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(root) {
    if (root._nbcrInit) return;
    var view = root.querySelector('[data-nbcr-viewport]');
    if (!view) return;
    root._nbcrInit = true;

    var prev = root.querySelector('[data-nbcr-prev]');
    var next = root.querySelector('[data-nbcr-next]');

    function step() {
      var slide = view.querySelector('.nbcr__slide');
      if (!slide) return view.clientWidth;
      var track = view.querySelector('.nbcr__track');
      var gap = track ? parseFloat(getComputedStyle(track).columnGap || '0') : 0;
      return slide.getBoundingClientRect().width + (isNaN(gap) ? 0 : gap);
    }

    function sync() {
      var max = view.scrollWidth - view.clientWidth - 2;
      if (prev) prev.disabled = view.scrollLeft <= 2;
      if (next) next.disabled = view.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { view.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { view.scrollBy({ left: step(), behavior: 'smooth' }); });

    var ticking = false;
    view.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { sync(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function initAll(scope) { (scope || document).querySelectorAll('.nbcr').forEach(initCarousel); }
  if (document.readyState !== 'loading') { initAll(); } else { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector ? e.target.querySelector('.nbcr') : null;
    if (r) { r._nbcrInit = false; initCarousel(r); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-energy"] && !Shopify.designMode) return;
  try {
    
(function () {
  function fill(fig) {
    fig.querySelectorAll('.fig__fill').forEach(function (el, i) {
      setTimeout(function () { el.style.width = (el.dataset.w || 0) + '%'; }, 120 + i * 180);
    });
  }
  function init(fig) {
    if (fig._nben) return; fig._nben = true;
    if (!('IntersectionObserver' in window)) { fill(fig); return; }
    new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { fill(en.target); obs.unobserve(en.target); }
      });
    }, { threshold: .25 }).observe(fig);
  }
  function boot() { document.querySelectorAll('[data-nben-fig]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal(scope) {
    var items = (scope || document).querySelectorAll('.nbg__item:not(.in)');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (e) { io.observe(e); });
  }
  if (document.readyState !== 'loading') { reveal(); } else { document.addEventListener('DOMContentLoaded', function () { reveal(); }); }
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-header-line"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-nbhl]').forEach(function (root) {
    var toggle = root.querySelector('[data-nbhl-toggle]');
    var scrim  = root.querySelector('[data-nbhl-scrim]');
    var closer = root.querySelector('[data-nbhl-close]');

    function setOpen(open) {
      root.classList.toggle('is-open', open);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    }

    if (toggle) toggle.addEventListener('click', function () {
      setOpen(!root.classList.contains('is-open'));
    });
    if (scrim) scrim.addEventListener('click', function () { setOpen(false); });
    if (closer) closer.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });

    if (root.classList.contains('nbhl--overlay')) {
      var onScroll = function () {
        root.classList.toggle('is-stuck', window.scrollY > 40);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-header"]) return;
  try {
    
(function () {
  function initHeader(wrap) {
    var header = wrap.querySelector('[data-nbh]');
    var ham = wrap.querySelector('.nbh__ham');
    var scrim = wrap.querySelector('[data-nbh-scrim]');
    if (!header || !ham) return;
    function open() { header.setAttribute('data-open', ''); wrap.classList.add('is-open'); ham.setAttribute('aria-expanded', 'true'); ham.setAttribute('aria-label', 'Menü schließen'); }
    function close() { header.removeAttribute('data-open'); wrap.classList.remove('is-open'); ham.setAttribute('aria-expanded', 'false'); ham.setAttribute('aria-label', 'Menü öffnen'); }
    ham.addEventListener('click', function () { header.hasAttribute('data-open') ? close() : open(); });
    if (scrim) scrim.addEventListener('click', close);
    wrap.querySelectorAll('[data-nbh-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    if (wrap.getAttribute('data-overlay') === 'true') {
      var threshold = Math.min(window.innerHeight * 0.62, 520);
      var ticking = false;
      function onScroll() {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () { wrap.classList.toggle('is-solid', window.scrollY > threshold); ticking = false; });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { threshold = Math.min(window.innerHeight * 0.62, 520); onScroll(); });
      onScroll();
    }
  }
  function initAll() { document.querySelectorAll('.nbh-wrap').forEach(initHeader); }
  if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) { var w = e.target.querySelector ? e.target.querySelector('.nbh-wrap') : null; if (w) initHeader(w); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-kontakt"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    root.querySelectorAll('[data-nbko-kopiere]').forEach(function (b) {
      if (b._nbko) return; b._nbko = true;
      b.addEventListener('click', function () {
        var text = b.dataset.nbkoKopiere;
        if (!navigator.clipboard || !navigator.clipboard.writeText) return;
        navigator.clipboard.writeText(text).then(function () {
          var alt = b.textContent;
          b.textContent = b.dataset.fertig || 'Kopiert';
          b.dataset.ok = '1';
          setTimeout(function () { b.textContent = alt; b.removeAttribute('data-ok'); }, 1600);
        }, function () {});
      });
    });
  }
  function boot() { document.querySelectorAll('.nbko').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-kurve"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SEQ = 0;

  var LAYOUT = {
    wide: { vb: '0 0 1100 480', X0: 90, X1: 1070, Y0: 410, Y1: 40,  maxTicks: 8, axY: [58, 300], axX: [580, 455] },
    tall: { vb: '0 0 520 640',  X0: 70, X1: 478,  Y0: 545, Y1: 50,  maxTicks: 4, axY: [34, 360], axX: [280, 605] }
  };

  function ksolve(tp, ke) {
    // ka so wählen, dass die Spitze bei tp liegt: ln(ka/ke)/(ka-ke) = tp
    var lo = ke * 1.05, hi = ke * 200;
    for (var i = 0; i < 60; i++) {
      var mid = (lo + hi) / 2;
      var t = Math.log(mid / ke) / (mid - ke);
      if (t > tp) lo = mid; else hi = mid;
    }
    return (lo + hi) / 2;
  }

  function init(root) {
    if (root._nbkv) return; root._nbkv = true;
    var svg = root.querySelector('.nbkv__svg');
    if (!svg) return;
    var d = root.dataset;
    var uid = 'k' + (++SEQ);
    var TMAX = parseFloat(d.tmax) || 7;

    var s1 = {
      peak: parseFloat(d.s1Peak) || .9,
      half: parseFloat(d.s1Half) || 5.5,
      height: (parseFloat(d.s1Height) || 95) / 100,
      color: d.s1Color || '#9a8d82',
      dash: d.s1Dash === '1',
      label: d.s1Label || ''
    };
    var s2 = {
      plateau: (parseFloat(d.s2Plateau) || 52) / 100,
      rise: parseFloat(d.s2Rise) || 2,
      color: d.s2Color || '#17784d',
      label: d.s2Label || ''
    };

    // Kurvenpunkte erzeugen. Zwei Modelle:
    // 'pk'  = Pharmakokinetik (Spitze + Abbau) gegen eine flache Plateaukurve  -> Koffein-Vergleich
    // 'sat' = Saettigung ueber Wochen: Ausgangsniveau (flach) gegen Aufbau bis Plateau
    var MODE = d.mode === 'sat' ? 'sat' : 'pk';
    var ke = Math.LN2 / s1.half, ka = ksolve(s1.peak, ke);
    var peakRaw = Math.exp(-ke * s1.peak) - Math.exp(-ka * s1.peak);
    var P1 = [], P2 = [], N = 60;
    for (var i = 0; i <= N; i++) {
      var t = TMAX * i / N, y1, y2;
      if (MODE === 'sat') {
        y1 = s1.height;                                        // Ausgangsniveau, bleibt flach
        y2 = s2.plateau * (1 - Math.exp(-t / s2.rise));        // Aufbau bis Plateau, ohne Abbau
      } else {
        y1 = (Math.exp(-ke * t) - Math.exp(-ka * t)) / peakRaw * s1.height;
        y2 = s2.plateau * (1 - Math.exp(-t / s2.rise)) * (1 - .22 * t / TMAX);
      }
      P1.push([t, Math.max(0, y1)]);
      P2.push([t, Math.max(0, y2)]);
    }

    var C = LAYOUT.wide;
    function px(t) { return C.X0 + (t / TMAX) * (C.X1 - C.X0); }
    function py(v) { return C.Y0 - v * (C.Y0 - C.Y1); }
    function path(pts) {
      var p = pts.map(function (q) { return [px(q[0]), py(q[1])]; });
      var s = 'M' + p[0][0].toFixed(1) + ',' + p[0][1].toFixed(1);
      for (var i = 1; i < p.length; i++) s += 'L' + p[i][0].toFixed(1) + ',' + p[i][1].toFixed(1);
      return s;
    }
    function area(pts) { return path(pts) + 'L' + px(TMAX) + ',' + C.Y0 + ' L' + px(0) + ',' + C.Y0 + ' Z'; }
    function val(pts, t) {
      var i = Math.round(t / TMAX * N);
      return pts[Math.max(0, Math.min(N, i))][1];
    }

    var g1 = svg.querySelector('[data-grad=s1]'), g2 = svg.querySelector('[data-grad=s2]');
    var cp = svg.querySelector('[data-clip]');
    g1.id = 'g1-' + uid; g2.id = 'g2-' + uid; cp.id = 'cp-' + uid;
    svg.querySelector('[data-plot]').setAttribute('clip-path', 'url(#cp-' + uid + ')');

    var a1 = svg.querySelector('[data-area=s1]'), a2 = svg.querySelector('[data-area=s2]');
    var l1 = svg.querySelector('[data-line=s1]'), l2 = svg.querySelector('[data-line=s2]');
    a1.setAttribute('fill', 'url(#g1-' + uid + ')');
    a2.setAttribute('fill', 'url(#g2-' + uid + ')');
    l1.setAttribute('stroke', s1.color);
    l2.setAttribute('stroke', s2.color);
    if (s1.dash) l1.setAttribute('stroke-dasharray', '7 6');

    var leg1 = root.querySelector('[data-leg=s1]'), leg2 = root.querySelector('[data-leg=s2]');
    if (leg1) { leg1.style.borderColor = s1.color; if (s1.dash) leg1.style.borderTopStyle = 'dashed'; }
    if (leg2) leg2.style.borderColor = s2.color;

    function render(layout) {
      C = LAYOUT[layout];
      svg.setAttribute('viewBox', C.vb);
      svg.classList.toggle('is-tall', layout === 'tall');

      var ay = svg.querySelector('[data-axis=y]'), ax = svg.querySelector('[data-axis=x]');
      ay.setAttribute('x1', C.X0); ay.setAttribute('x2', C.X0);
      ay.setAttribute('y1', C.Y1 - 20); ay.setAttribute('y2', C.Y0);
      ax.setAttribute('x1', C.X0); ax.setAttribute('x2', C.X1);
      ax.setAttribute('y1', C.Y0); ax.setAttribute('y2', C.Y0);

      var ly = svg.querySelector('[data-lab=y]'), lx = svg.querySelector('[data-lab=x]');
      ly.textContent = d.axisY || '';
      ly.setAttribute('transform', 'translate(' + C.axY[0] + ',' + C.axY[1] + ') rotate(-90)');
      lx.textContent = d.axisX || '';
      lx.setAttribute('x', C.axX[0]); lx.setAttribute('y', C.axX[1]);

      var step = Math.max(1, Math.ceil(TMAX / C.maxTicks));
      var ticks = svg.querySelector('[data-ticks]');
      ticks.innerHTML = '';
      for (var t = 0; t <= TMAX; t += step) {
        var x = px(t);
        ticks.insertAdjacentHTML('beforeend',
          '<line class="nbkv__ax" x1="' + x + '" y1="' + C.Y0 + '" x2="' + x + '" y2="' + (C.Y0 + 6) + '"/>' +
          '<text class="nbkv__tick" x="' + x + '" y="' + (C.Y0 + 24) + '" text-anchor="middle">' + t + '</text>');
      }

      l1.setAttribute('d', path(P1));
      l2.setAttribute('d', path(P2));
      a1.setAttribute('d', area(P1));
      a2.setAttribute('d', area(P2));

      var labels = svg.querySelector('[data-labels]');
      labels.innerHTML = '';
      if (s1.label) {
        var t1 = MODE === 'sat' ? TMAX * .5 : s1.peak;         // flache Linie: Titel in die Mitte
        labels.insertAdjacentHTML('beforeend',
          '<text class="nbkv__serieslab" x="' + (px(t1) + 16) + '" y="' + (py(val(P1, t1)) - 14) + '">' + s1.label + '</text>');
      }

      // Studien-Marker auf der Aufbaukurve
      var mg = svg.querySelector('[data-markers-g]');
      if (mg) {
        mg.innerHTML = '';
        var marks = [];
        try { marks = JSON.parse(d.markers || '[]'); } catch (e) { marks = []; }
        marks.forEach(function (m) {
          var mt = Math.max(0, Math.min(TMAX, parseFloat(m.t) || 0));
          var x = px(mt), y = py(val(P2, mt));
          mg.insertAdjacentHTML('beforeend',
            '<circle class="nbkv__dot" cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="5" style="fill:' + s2.color + '"/>' +
            '<line class="nbkv__droplin" x1="' + x.toFixed(1) + '" y1="' + y.toFixed(1) + '" x2="' + x.toFixed(1) + '" y2="' + C.Y0 + '"/>' +
            (m.l ? '<text class="nbkv__marklab" x="' + x.toFixed(1) + '" y="' + (y - 18).toFixed(1) + '" text-anchor="middle">' + m.l + '</text>' : ''));
        });
      }
      if (layout === 'tall') return;
      if (s2.label) {
        var tl = TMAX * .78;
        labels.insertAdjacentHTML('beforeend',
          '<text class="nbkv__serieslab" x="' + px(tl) + '" y="' + (py(val(P2, tl)) - 30) + '" text-anchor="middle">' + s2.label + '</text>');
      }
      if (d.annot) {
        var ta = TMAX * .99, mid = (val(P1, ta) + val(P2, ta)) / 2;
        labels.insertAdjacentHTML('beforeend',
          '<text class="nbkv__annot" x="' + px(ta) + '" y="' + py(mid) + '" text-anchor="end">' + d.annot + '</text>');
      }
    }

    var mq = window.matchMedia('(max-width: 749px)');
    function apply() { render(mq.matches ? 'tall' : 'wide'); }
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es, obs) {
        es.forEach(function (en) {
          if (en.isIntersecting) { root.classList.add('is-on'); obs.unobserve(en.target); }
        });
      }, { threshold: .2 }).observe(root);
    } else {
      root.classList.add('is-on');
    }
  }

  function boot() { document.querySelectorAll('[data-nbkv]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-landing"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els = document.querySelectorAll('.nbase .reveal');
  if (!('IntersectionObserver' in window) || reduce) {
    els.forEach(function (e) { e.classList.add('in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-manifesto"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initManifesto(root) {
    var track = root.querySelector('.nbmf__track');
    var slides = root.querySelectorAll('.nbmf__slide');
    var cur = root.querySelector('.nbmf__cur');
    var arrows = root.querySelectorAll('.nbmf__arrow');
    if (!track || slides.length === 0) return;
    var i = 0, n = slides.length, timer = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function go(idx) {
      i = (idx + n) % n;
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      if (cur) cur.textContent = (i + 1);
    }
    arrows.forEach(function (a) {
      a.addEventListener('click', function () {
        go(i + (a.getAttribute('data-dir') === 'next' ? 1 : -1));
        restart();
      });
    });

    function start() {
      if (reduce || root.getAttribute('data-autoplay') !== 'true' || n < 2) return;
      var sec = parseInt(root.getAttribute('data-speed'), 10) || 6;
      timer = setInterval(function () { go(i + 1); }, sec * 1000);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    // Editor: Block auswählen → Slide zeigen
    root._nbmfGo = go;
    go(0); start();
  }
  function initAll() { document.querySelectorAll('.nbmf').forEach(initManifesto); }
  if (document.readyState !== 'loading') { initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector ? e.target.querySelector('.nbmf') : null; if (r) initManifesto(r);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest ? e.target.closest('.nbmf') : null; if (!root || !root._nbmfGo) return;
    var slide = e.target.closest('.nbmf__slide'); if (slide) root._nbmfGo(parseInt(slide.getAttribute('data-index'), 10) || 0);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-network"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root._nbnet) return; root._nbnet = true;
    var canvas = root.querySelector('.nbnet__canvas');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    var d = root.dataset;
    var NODE = d.node || '#3f5147', LINE = d.line || '#9aa79f', GLOW = d.glow || '#2f6b4f';
    var density = parseFloat(d.density) || 1;
    var REACH = parseFloat(d.reach) || 190;
    var PULL = parseFloat(d.pull); if (isNaN(PULL)) PULL = 4;
    var AUTO = parseFloat(d.autospeed) || 4;

    var nodes = [], w = 0, h = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
    var p = { x: -9999, y: -9999, active: false };
    var t = Math.random() * 1000, running = true;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoAlways = !window.matchMedia('(hover: hover)').matches;

    function size() {
      var r = root.getBoundingClientRect();
      var nw = Math.round(r.width), nh = Math.round(r.height);
      if (!nw || !nh) return;
      canvas.width = nw * dpr; canvas.height = nh * dpr;
      canvas.style.width = nw + 'px'; canvas.style.height = nh + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      // Nur die Breite löst einen Neuaufbau aus. Auf dem Handy ändert sich beim
      // Scrollen laufend die Höhe (Adressleiste) — das darf das Netz nicht anfassen.
      var breiteNeu = Math.abs(nw - w) > 1;
      w = nw; h = nh;
      if (!nodes.length || breiteNeu) build();
    }
    function build() {
      var count = Math.round((w * h) / 16000 * density);
      count = Math.max(24, Math.min(160, count));
      nodes = [];
      for (var i = 0; i < count; i++) {
        nodes.push({
          x: Math.random() * w, y: Math.random() * h,
          vx: (Math.random() - .5) * .20, vy: (Math.random() - .5) * .20,
          r: Math.random() * 1.5 + .9
        });
      }
    }

    function frame() {
      if (!running) return;
      t += 0.0016 * AUTO;
      if (!p.active && autoAlways) {
        p.x = w * (0.5 + 0.34 * Math.sin(t * 0.9) * Math.cos(t * 0.37));
        p.y = h * (0.5 + 0.30 * Math.sin(t * 0.63 + 1.1));
      }
      var live = p.active || autoAlways;

      ctx.clearRect(0, 0, w, h);

      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (!reduce) { n.x += n.vx; n.y += n.vy; }
        if (n.x < 0) { n.x = 0; n.vx = Math.abs(n.vx); }
        else if (n.x > w) { n.x = w; n.vx = -Math.abs(n.vx); }
        if (n.y < 0) { n.y = 0; n.vy = Math.abs(n.vy); }
        else if (n.y > h) { n.y = h; n.vy = -Math.abs(n.vy); }
        if (PULL > 0 && live) {
          var ax = p.x - n.x, ay = p.y - n.y, ad = Math.sqrt(ax*ax + ay*ay);
          if (ad < REACH && ad > 1) {
            var f = (1 - ad / REACH) * PULL * 0.012;
            n.x += ax / ad * f; n.y += ay / ad * f;
          }
        }
      }

      for (var a = 0; a < nodes.length; a++) {
        var na = nodes[a];
        var da = Math.sqrt((na.x-p.x)*(na.x-p.x) + (na.y-p.y)*(na.y-p.y));
        var aNear = live && da < REACH;
        for (var b = a + 1; b < nodes.length; b++) {
          var nb = nodes[b];
          var db = Math.sqrt((nb.x-p.x)*(nb.x-p.x) + (nb.y-p.y)*(nb.y-p.y));
          var bNear = live && db < REACH;
          var boost = 0;
          if (aNear) boost += (1 - da / REACH);
          if (bNear) boost += (1 - db / REACH);
          var maxD = 120 + boost * 45;
          var dx = na.x - nb.x, dy = na.y - nb.y;
          var dd = Math.sqrt(dx*dx + dy*dy);
          if (dd < maxD) {
            var near = aNear || bNear;
            ctx.globalAlpha = (1 - dd / maxD) * (near ? 0.55 + boost * 0.18 : 0.26);
            ctx.strokeStyle = near ? GLOW : LINE;
            ctx.lineWidth = near ? 0.9 : 0.7;
            ctx.beginPath(); ctx.moveTo(na.x, na.y); ctx.lineTo(nb.x, nb.y); ctx.stroke();
          }
        }
      }

      if (live) {
        for (var k = 0; k < nodes.length; k++) {
          var nk = nodes[k];
          var dk = Math.sqrt((nk.x-p.x)*(nk.x-p.x) + (nk.y-p.y)*(nk.y-p.y));
          if (dk < REACH) {
            ctx.globalAlpha = (1 - dk / REACH) * 0.7;
            ctx.strokeStyle = GLOW; ctx.lineWidth = 1;
            ctx.beginPath(); ctx.moveTo(nk.x, nk.y); ctx.lineTo(p.x, p.y); ctx.stroke();
          }
        }
      }

      for (var j = 0; j < nodes.length; j++) {
        var q = nodes[j];
        var dq = Math.sqrt((q.x-p.x)*(q.x-p.x) + (q.y-p.y)*(q.y-p.y));
        var nearQ = live && dq < REACH;
        var amt = nearQ ? (1 - dq / REACH) : 0;
        ctx.globalAlpha = 0.55 + amt * 0.45;
        ctx.fillStyle = nearQ ? GLOW : NODE;
        ctx.beginPath();
        ctx.arc(q.x, q.y, q.r * (1 + amt * 0.9), 0, Math.PI * 2);
        ctx.fill();
      }

      ctx.globalAlpha = 1;
      window.requestAnimationFrame(frame);
    }

    // Nur echte Mauszeiger reagieren. Auf Touch-Geräten löst Scrollen
    // dieselben Ereignisse aus — das wirkte beim Wischen unruhig.
    root.addEventListener('pointermove', function (e) {
      if (autoAlways || e.pointerType !== 'mouse') return;
      var r = root.getBoundingClientRect();
      p.x = e.clientX - r.left; p.y = e.clientY - r.top; p.active = true;
    });
    root.addEventListener('pointerleave', function () { p.active = false; });
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(size, 150);
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting) { if (!running) { running = true; frame(); } }
          else running = false;
        });
      }).observe(root);
    }

    size(); frame();
  }

  function boot() { document.querySelectorAll('[data-nbnet]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-process"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initProcess(root) {
    var track = root.querySelector('.npr__track');
    var fill = root.querySelector('.npr__fill');
    var steps = root.querySelectorAll('.npr__step');
    if (!track || !fill) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { fill.style.height = '100%'; steps.forEach(function (s) { s.classList.add('on'); }); return; }
    var ticking = false;
    function compute() {
      var r = track.getBoundingClientRect();
      var p = (window.innerHeight * 0.62 - r.top) / (r.height * 0.9);
      p = Math.max(0, Math.min(1, p));
      fill.style.height = (p * 100) + '%';
      steps.forEach(function (s, k) { s.classList.toggle('on', p >= (k + 0.4) / steps.length); });
      ticking = false;
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(compute); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    compute();
  }
  function initAll() { document.querySelectorAll('.npr').forEach(initProcess); }
  if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector ? e.target.querySelector('.npr') : null; if (r) initProcess(r); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-promobar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPromo(root) {
    if (root._npbInit) return; root._npbInit = true;
    // Rotation
    var track = root.querySelector('.npb__track');
    var msgs = root.querySelectorAll('.npb__msg');
    var i = 0, n = msgs.length, timer = null;
    function go(x) { i = (x + n) % n; if (track) track.style.transform = 'translateX(' + (-i * 100) + '%)'; }
    root.querySelectorAll('[data-npb-dir]').forEach(function (b) {
      b.addEventListener('click', function () { go(i + (b.getAttribute('data-npb-dir') === 'next' ? 1 : -1)); restart(); });
    });
    function start() { if (root.getAttribute('data-autorotate') === 'true' && n > 1) { var s = parseInt(root.getAttribute('data-speed'), 10) || 5; timer = setInterval(function () { go(i + 1); }, s * 1000); } }
    function restart() { if (timer) clearInterval(timer); start(); }
    root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    start();

    // Countdown
    if (root.getAttribute('data-countdown') !== 'true') return;
    var cd = root.querySelector('[data-npb-cd]'); if (!cd) return;
    var endStr = (root.getAttribute('data-end') || '').trim();
    var end;
    if (endStr) { end = new Date(endStr.replace(' ', 'T')); }
    if (!end || isNaN(end.getTime())) {
      // Fallback: bis kommenden Montag 00:00 ("diese Woche")
      end = new Date(); var day = end.getDay(); var add = ((8 - day) % 7) || 7;
      end.setDate(end.getDate() + add); end.setHours(0, 0, 0, 0);
    }
    var els = { d: cd.querySelector('[data-d]'), h: cd.querySelector('[data-h]'), m: cd.querySelector('[data-m]'), s: cd.querySelector('[data-s]') };
    function pad(x) { return (x < 10 ? '0' : '') + x; }
    function tick() {
      var diff = Math.max(0, end.getTime() - Date.now());
      var t = Math.floor(diff / 1000);
      els.d.textContent = pad(Math.floor(t / 86400));
      els.h.textContent = pad(Math.floor((t % 86400) / 3600));
      els.m.textContent = pad(Math.floor((t % 3600) / 60));
      els.s.textContent = pad(t % 60);
      if (diff <= 0 && root.getAttribute('data-end')) { root.style.display = 'none'; }
    }
    tick(); setInterval(tick, 1000);
  }
  function initAll() { document.querySelectorAll('.npb').forEach(initPromo); }
  if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector ? e.target.querySelector('.npb') : null; if (r) { r._npbInit = false; initPromo(r); } });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-quiz"] && !Shopify.designMode) return;
  try {
    
(function () {
  var CHECK = '<svg class="nbq__check" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M2 6.5 5 9l5-6"/></svg>';
  var STORE = 'nbase-quiz';

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function slug(s) {
    return String(s).toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
  }
  function save(v) { try { sessionStorage.setItem(STORE, JSON.stringify(v)); } catch (e) {} }
  function load() { try { return JSON.parse(sessionStorage.getItem(STORE) || 'null'); } catch (e) { return null; } }
  function flag(k, v) { try { if (v === undefined) return sessionStorage.getItem(STORE + '-' + k); sessionStorage.setItem(STORE + '-' + k, v); } catch (e) { return null; } }

  function init(root) {
    if (root._nbq) return; root._nbq = true;
    var Q = JSON.parse(root.querySelector('[data-nbq-questions]').textContent || '[]');
    var T = JSON.parse(root.querySelector('[data-nbq-texts]').textContent || '{}');
    var stage = root.querySelector('[data-nbq-stage]');
    var TOTAL = Q.length + 1;
    var A = {}, i = 0, emailError = false;

    // Rückkehr nach dem Absenden des Kundenformulars
    var probe = root.querySelector('[data-nbq-posted]');
    var stored = load();
    if (probe && stored) {
      A = stored.A || {};
      if (probe.dataset.nbqPosted === 'ok') i = TOTAL; else { i = Q.length; emailError = true; }
      var top = root.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo(0, Math.max(0, top));
    }

    function byKey(key) { for (var k = 0; k < Q.length; k++) if (Q[k].key === key) return Q[k]; return null; }
    function pick(key) { return (A[key] || [])[0]; }
    function has(key, n) { return (A[key] || []).indexOf(n) > -1; }
    function label(key, n) { var q = byKey(key); return q && q.o[n] ? q.o[n][0] : ''; }

    function summary() {
      return Q.map(function (q) { return (A[q.key] || []).map(function (n) { return q.o[n] ? q.o[n][0] : ''; }).join(', '); })
        .filter(Boolean).join(' · ');
    }
    function tags() {
      var t = ['quiz'];
      Q.forEach(function (q) { (A[q.key] || []).forEach(function (n) { if (q.o[n]) t.push('quiz-' + slug(q.key) + '-' + slug(q.o[n][0])); }); });
      if (pick('paket') === 3) t.push('quiz-nur-info');
      return t.join(', ');
    }

    // Anonyme Auswertung: eine Zeile pro Durchgang im Google Sheet
    var sheet = root.dataset.sheetUrl;
    var returning = !!(probe && stored);
    if (!returning) { try { sessionStorage.removeItem(STORE + '-sent'); sessionStorage.removeItem(STORE + '-id'); } catch (e) {} }
    var sid = flag('id') || Math.random().toString(36).slice(2, 10);
    flag('id', sid);
    var furthest = i;
    function row(status, email) {
      var d = { id: sid, status: status, schritt: Math.min(furthest + 1, TOTAL) + ' / ' + TOTAL, email: email ? 'ja' : 'nein',
        geraet: window.innerWidth < 750 ? 'Handy' : 'Desktop' };
      Q.forEach(function (q) { d[q.key] = (A[q.key] || []).map(function (n) { return q.o[n] ? q.o[n][0] : ''; }).join(', '); });
      return JSON.stringify(d);
    }
    function send(status, email) {
      if (!sheet || flag('sent')) return;
      flag('sent', '1');
      var body = row(status, email);
      try {
        if (navigator.sendBeacon) navigator.sendBeacon(sheet, new Blob([body], { type: 'text/plain' }));
        else fetch(sheet, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: body });
      } catch (e) {}
    }
    window.addEventListener('pagehide', function () {
      if (furthest > 0 && i < TOTAL) send('abgebrochen', false);
    });

    function progress() {
      root.querySelector('[data-nbq-count]').textContent = i < TOTAL ? (i + 1) + ' / ' + TOTAL : '';
      root.querySelector('[data-nbq-fill]').style.width = (i >= TOTAL ? 100 : (i / TOTAL) * 100) + '%';
      root.querySelector('[data-nbq-back]').classList.toggle('is-on', i > 0);
    }
    var drawn = false;
    function render() {
      if (i > furthest) furthest = i;
      progress();
      if (i < Q.length) question(Q[i]);
      else if (i === Q.length) email();
      else result();
      // Neue Frage sichtbar machen, wenn die Seite noch weiter unten steht
      if (drawn) {
        var top = root.getBoundingClientRect().top;
        if (top < 0) window.scrollTo({ top: top + window.pageYOffset - 90, behavior: 'smooth' });
      }
      drawn = true;
    }

    function question(s) {
      var sel = A[s.key] || [];
      var h = '<div class="nbq__step"><p class="nbq__eyebrow">' + esc(T.eyebrow) + '</p><h2 class="nbq__q">' + esc(s.q) + '</h2>' +
        (s.hint ? '<p class="nbq__hint">' + esc(s.hint) + '</p>' : '') + '<ul class="nbq__opts">';
      s.o.forEach(function (o, k) {
        h += '<li><button type="button" class="nbq__opt" data-k="' + k + '" aria-pressed="' + (sel.indexOf(k) > -1) + '">' + CHECK +
          '<span>' + esc(o[0]) + (o[1] ? '<span class="nbq__sub">' + esc(o[1]) + '</span>' : '') + '</span></button></li>';
      });
      h += '</ul><button type="button" class="nbq__btn" data-nbq-next' + (sel.length ? '' : ' disabled') + '>Weiter</button></div>';
      stage.innerHTML = h;
      var next = stage.querySelector('[data-nbq-next]');
      stage.querySelectorAll('.nbq__opt').forEach(function (b) {
        b.addEventListener('click', function () {
          var k = +b.dataset.k, cur = A[s.key] || [];
          if (s.multi) cur = cur.indexOf(k) > -1 ? cur.filter(function (x) { return x !== k; }) : cur.concat(k);
          else cur = [k];
          A[s.key] = cur;
          stage.querySelectorAll('.nbq__opt').forEach(function (x) { x.setAttribute('aria-pressed', cur.indexOf(+x.dataset.k) > -1); });
          next.disabled = !cur.length;
          if (!s.multi) setTimeout(function () { i++; render(); }, 220);
        });
      });
      next.addEventListener('click', function () { i++; render(); });
    }

    function email() {
      var tpl = root.querySelector('[data-nbq-form]');
      stage.innerHTML = '<div class="nbq__step"><p class="nbq__eyebrow">' + esc(T.eyebrow) + '</p><h2 class="nbq__q">' + esc(T.emailTitle) + '</h2>' +
        '<p class="nbq__hint">' + esc(T.emailText) + '</p>' +
        (emailError ? '<p class="nbq__error">Das hat nicht geklappt. Bitte prüfe deine E-Mail-Adresse.</p>' : '') +
        '<div data-nbq-formslot></div>' +
        '<button type="button" class="nbq__btn nbq__btn--ghost" data-nbq-skip>' + esc(T.skipBtn) + '</button>' +
        '<p class="nbq__fine">' + esc(T.emailFine) + '</p></div>';
      var slot = stage.querySelector('[data-nbq-formslot]');
      slot.appendChild(tpl.content.cloneNode(true));
      slot.querySelector('[data-nbq-tags]').value = tags();
      slot.querySelector('[data-nbq-emailbtn]').textContent = T.emailBtn;
      var form = slot.querySelector('form');
      if (form) {
        form.action = form.action.split('#')[0] + '#' + root.id;
        form.addEventListener('submit', function () { save({ A: A }); furthest = TOTAL; send('fertig', true); });
      }
      stage.querySelector('[data-nbq-skip]').addEventListener('click', function () { save({ A: A }); i++; render(); });
    }

    function result() {
      send('fertig', false);
      var info = pick('paket') === 3;
      var paket = [['Probierset', '10 Sachets'], ['1 Box', '30 Sachets, ein Monat'], ['Phasen-Paket', '60 Sachets, zwei Monate'],
        ['Wissen zuerst', 'Wir halten dich auf dem Laufenden, ganz ohne Kauf.']][pick('paket') || 0];
      var zeit = ['Direkt nach dem Aufstehen, noch vor dem ersten Termin.', 'Zum Frühstück, bevor du loslegst.',
        'Am späten Morgen, zum Start deiner ersten Lern- oder Arbeitsphase.',
        'Immer zur selben Zeit am Morgen. Die Routine ist wichtiger als die Uhrzeit.'][pick('start') || 0];
      var phase = pick('phase');
      var phaseTxt = ['deine Lernphase', 'deine Prüfungswoche', 'deine Deadline', 'deine Meeting-Wochen', 'deinen Alltag'][phase === undefined ? 4 : phase] || 'deinen Alltag';

      var why = [], W = T.why || [];
      if (has('wichtig', 0)) why.push(W[0]);
      if (has('wichtig', 1) || pick('kaffee') >= 2) why.push(W[1]);
      if (has('wichtig', 2)) why.push(W[2]);
      if (has('wichtig', 3)) why.push(W[3]);
      if (has('wichtig', 4) || !why.length) why.push(W[4]);
      why = why.filter(function (w) { return w && w[0]; });

      stage.innerHTML = '<div class="nbq__step is-result"><p class="nbq__eyebrow">' + esc(T.resultEyebrow) + '</p>' +
        '<h2 class="nbq__q">Deine Basis für ' + esc(phaseTxt) + '.</h2>' +
        '<p class="nbq__hint">' + esc(info ? T.resultLeadInfo : T.resultLead) + '</p>' +
        '<div class="nbq__plan">' +
          '<div class="nbq__cell"><h3>Dein Start</h3><strong>' + esc(paket[0]) + '</strong><p>' + esc(paket[1]) + '</p></div>' +
          '<div class="nbq__cell"><h3>Wann</h3><strong>Ein Sachet</strong><p>' + esc(zeit) + '</p></div>' +
        '</div>' +
        '<ul class="nbq__why">' + why.map(function (w) { return '<li><b>' + esc(w[0]) + '</b>' + esc(w[1]) + '</li>'; }).join('') + '</ul>' +
        (info
          ? '<a class="nbq__btn" href="' + esc(root.dataset.infoUrl) + '">' + esc(T.infoBtn) + '</a>'
          : '<button type="button" class="nbq__btn" data-nbq-buy>' + esc(T.buyBtn) + '</button>') +
        '<button type="button" class="nbq__link" data-nbq-again>Quiz neu starten</button>' +
        '<p class="nbq__legal">' + esc(T.legal) + '</p></div>';

      var buy = stage.querySelector('[data-nbq-buy]');
      if (buy) buy.addEventListener('click', function () {
        buy.disabled = true;
        // Antworten als Warenkorb-Attribut: erscheinen an der Bestellung im Admin
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Quiz': summary() } })
        }).catch(function () {}).then(function () { window.location.href = root.dataset.productUrl; });
      });
      stage.querySelector('[data-nbq-again]').addEventListener('click', function () {
        A = {}; i = 0; furthest = 0; emailError = false; save(null);
        sid = Math.random().toString(36).slice(2, 10); flag('id', sid); try { sessionStorage.removeItem(STORE + '-sent'); } catch (e) {}
        render();
      });
    }

    root.querySelector('[data-nbq-back]').addEventListener('click', function () { if (i > 0) { i--; emailError = false; render(); } });
    render();
  }

  function boot() { document.querySelectorAll('[data-nbq]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-range"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root._nbrg) return; root._nbrg = true;
    var track = root.querySelector('[data-nbrg-track]');
    var dots = root.querySelector('[data-nbrg-dots]');
    if (!track || !dots) return;
    var items = dots.querySelectorAll('i');

    function update() {
      if (!track.scrollWidth || track.scrollWidth <= track.clientWidth) return;
      var cards = track.children;
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestD = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        var center = c.offsetLeft + c.offsetWidth / 2;
        var dd = Math.abs(center - mid);
        if (dd < bestD) { bestD = dd; best = i; }
      }
      for (var j = 0; j < items.length; j++) {
        items[j].classList.toggle('is-on', j === best);
      }
      for (var k = 0; k < cards.length; k++) {
        cards[k].classList.toggle('is-center', k === best);
      }
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });
    update();
  }

  function boot() { document.querySelectorAll('[data-nbrg]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-spotlight"] && !Shopify.designMode) return;
  try {
    
(function () {
  function run(el, dur) {
    var raw = el.getAttribute('data-nbsl-count') || '';
    var m = raw.match(/^([^0-9]*)([0-9][0-9'’.,\s]*)(.*)$/);
    if (!m) return;
    var digits = m[2].replace(/[^0-9]/g, '');
    var target = parseInt(digits, 10);
    if (!target || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var sep = (m[2].match(/['’\s]/) || [''])[0];
    function fmt(n) { var s = String(n); return sep ? s.replace(/\B(?=(\d{3})+(?!\d))/g, sep) : s; }
    var t0 = null;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
      el.textContent = m[1] + fmt(Math.round(target * e)) + m[3];
      if (p < 1) requestAnimationFrame(step); else el.textContent = raw;
    }
    el.textContent = m[1] + '0' + m[3];
    requestAnimationFrame(step);
  }
  function init(root) {
    if (root._nbsl) return; root._nbsl = true;
    var dur = parseInt(root.getAttribute('data-nbsl-dur'), 10) || 1400;
    var els = root.querySelectorAll('[data-nbsl-count]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); run(en.target, dur); } });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }
  function boot() { document.querySelectorAll('[data-nbsl]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-stats"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal(root) {
    if (!root.classList.contains('nbst--anim')) return;
    var items = root.querySelectorAll('.nbst__r');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var i = [].indexOf.call(items, el);
        setTimeout(function () { el.classList.add('in'); }, Math.max(0, i) * 80);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    items.forEach(function (el) { io.observe(el); });
  }
  function initAll() { document.querySelectorAll('.nbst').forEach(reveal); }
  if (document.readyState !== 'loading') { initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector ? e.target.querySelector('.nbst') : null;
    if (r) r.querySelectorAll('.nbst__r').forEach(function (el) { el.classList.add('in'); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-steps"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal(scope) {
    var steps = (scope || document).querySelectorAll('.nst__step:not(.in)');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      steps.forEach(function (e) { e.classList.add('in'); }); return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });
    steps.forEach(function (e) { io.observe(e); });
  }
  if (document.readyState !== 'loading') reveal(); else document.addEventListener('DOMContentLoaded', function () { reveal(); });
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-studies"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initStudies(root) {
    var links = root.querySelectorAll('.std__navlink');
    var heads = root.querySelectorAll('.std__head');
    if (!links.length || !('IntersectionObserver' in window)) return;
    var map = {};
    links.forEach(function (l) { map[l.getAttribute('data-target')] = l; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          links.forEach(function (l) { l.classList.remove('is-active'); });
          var a = map[e.target.id]; if (a) a.classList.add('is-active');
        }
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    heads.forEach(function (h) { io.observe(h); });
  }
  function initAll() { document.querySelectorAll('.std').forEach(initStudies); }
  if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector ? e.target.querySelector('.std') : null; if (r) initStudies(r); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-team"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal(root) {
    if (!root.classList.contains('nbte--anim')) return;
    var items = root.querySelectorAll('.nbte__r');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var i = [].indexOf.call(items, el);
        setTimeout(function () { el.classList.add('in'); }, Math.max(0, i) * 90);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
  }
  function initAll() { document.querySelectorAll('.nbte').forEach(reveal); }
  if (document.readyState !== 'loading') { initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector ? e.target.querySelector('.nbte') : null;
    if (r) { r.querySelectorAll('.nbte__r').forEach(function (el) { el.classList.add('in'); }); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbase-timeline"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal(scope) {
    var items = (scope || document).querySelectorAll('.nbt__item:not(.in)');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach(function (e) { e.classList.add('in'); }); return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (e) { io.observe(e); });
  }
  if (document.readyState !== 'loading') { reveal(); } else { document.addEventListener('DOMContentLoaded', function () { reveal(); }); }
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
